// extracted by mini-css-extract-plugin
module.exports = {"container":"PropertyAction_container__1aqpu","menu":"PropertyAction_menu__33jHP","view":"PropertyAction_view__2d87H","delete":"PropertyAction_delete__XOrfQ"};